// src/components/pages/PrivacyPolicy.js
import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css'; // We'll create this shared CSS file

const PrivacyPolicy = () => {
  const effectiveDate = "May 20, 2025"; // Update this as needed
  const businessName = "SalonLogic"; // Your business name
  const contactEmail = "andrew@salonlogic.co.uk"; // Your contact email
  const businessAddress = "64a Cumberland Street, Edinburgh, EH3 6RF"; // Your address
  
  return (
    <div className="legal-page-container">
      <div className="legal-page">
        <h1>Salon Pricing Calculator – Privacy Policy</h1>
        <p className="effective-date"><strong>Effective from: {effectiveDate}</strong></p>
        
        <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, store, and protect your personal information when you use <strong>salonpricingcalculator.co.uk</strong> ("Website"), owned and operated by <strong>SalonLogic</strong>.</p>
        
        <h2>1. What Information We Collect</h2>
        <p>We collect information that you voluntarily provide when you:</p>
        <ul>
          <li>Sign up or register for the calculator</li>
          <li>Purchase a subscription or product</li>
          <li>Contact us via email or forms</li>
          <li>Access support or request updates</li>
        </ul>
        
        <p>This may include:</p>
        <ul>
          <li>Your name</li>
          <li>Email address</li>
          <li>Business name (if applicable)</li>
          <li>Billing address</li>
          <li>Purchase history</li>
          <li>Technical data (browser, IP address, time of access)</li>
        </ul>
        
        <p>We do <strong>not</strong> store your card or payment details. All transactions are processed securely by our payment partners.</p>
        
        <h2>2. How We Use Your Information</h2>
        <p>We use your data to:</p>
        <ul>
          <li>Deliver the services you've purchased</li>
          <li>Communicate important account or subscription updates</li>
          <li>Provide customer support</li>
          <li>Improve our tools and website experience</li>
          <li>Comply with legal and accounting obligations</li>
        </ul>
        
        <p>We may also send occasional emails about relevant product updates, resources, or offers. You can unsubscribe at any time.</p>
        
        <h2>3. Data Sharing</h2>
        <p>We never sell your personal data.</p>
        <p>Your information may be shared only with:</p>
        <ul>
          <li>Our secure payment processor (e.g. Stripe or PayPal)</li>
          <li>Our hosting or email provider (e.g. for transactional emails)</li>
          <li>Legal or regulatory authorities if required by law</li>
        </ul>
        
        <p>All third-party services we use are GDPR-compliant and bound by data protection agreements.</p>
        
        <h2>4. Cookies & Analytics</h2>
        <p>Our website uses cookies for basic functionality, analytics (e.g. Google Analytics), and to improve your experience.</p>
        <p>Cookies allow us to track anonymous usage data and tailor content. You can disable cookies in your browser at any time, though some site features may be affected.</p>
        
        <h2>5. Data Retention</h2>
        <p>We retain your information for as long as your account is active or as needed to comply with legal, tax, or contractual obligations.</p>
        <p>You may request that we delete your account and associated personal data at any time.</p>
        
        <h2>6. Your Rights</h2>
        <p>Under UK and EU data laws, you have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Request corrections to inaccurate information</li>
          <li>Request deletion of your data</li>
          <li>Object to or restrict certain data uses</li>
          <li>Request data portability</li>
        </ul>
        
        <p>To make a request, contact us at <strong>privacy@salonpricingcalculator.co.uk</strong> and we will respond within 30 days.</p>
        
        <h2>7. Keeping Your Data Secure</h2>
        <p>We follow best practices in data storage and access control. Access to your personal data is limited to only those who need it to perform business operations.</p>
        <p>We use HTTPS encryption across the website and enforce two-factor authentication for admin access.</p>
        
        <h2>8. Children's Privacy</h2>
        <p>Our services are not intended for users under 18. We do not knowingly collect data from minors. If you believe we've collected information about a child, please contact us immediately.</p>
        
        <h2>9. Updates to This Policy</h2>
        <p>This policy may be updated from time to time. The most current version will always be available on our Website. Continued use of our services constitutes acceptance of any updates.</p>
        
        <h2>10. Contact Us</h2>
        <p>Questions or concerns?</p>
        <p>Email: support@salponpricingcalculator.co.uk</p>
        <p>Address: 64a Cumberland Street, Edinburgh, EH3 6RF</p>
        <p>We take your privacy seriously and are committed to protecting your personal data.</p>
        
        <div className="legal-footer">
          <Link to="/">Return to Dashboard</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;